/**
 * Figma color DSM https://www.figma.com/file/Wto9cGzPiM33eOCpil9E8y/Colors---Foundation-Light?node-id=0%3A1
 */

const primary = {
  "ltk-black": "#000000",
  "ltk-white": "#FFFFFF",
};

const grey = {
  "grey-80": "#222222",
  "grey-70": "#525252",
  "grey-50": "#757575",
  "disabled-grey": "#9E9E9E",
  "grey-30": "#CCCCCC",
  "grey-20": "#EBEBEB",
  "grey-10": "#F0F0F0",
  "grey-5": "#FAFAFA",
};

/**
 * UI Color
 */
const link = {
  "link-light": "#0469E0",
  "link-dark": "#43B9D3",
};

const success = {
  "success-50": "#1B8659",
  "success-40": "#51CA98",
  "success-20": "#91E3C1",
  "success-10": "#DEF3EA",
  "success-90": "#0F4B32",
};

const error = {
  "error-50": "#CE4646",
  "error-40": "#FE636D",
  "error-20": "#EF9086",
  "error-10": "#FDE9E8",
  "error-90": "#5D1710",
};

const warning = {
  "warning-40": "#FFB300",
  "warning-20": "#FED983",
  "warning-10": "#FEEECD",
  "warning-90": "#664800",
};

/**
 * Secondary Color
 */
const brand = {
  "brand-secondary-70": "#2C432D",
  "brand-secondary-60": "#527A70",
  "brand-secondary-50": "#577F68",
  "brand-secondary-30": "#96C0A7",
  "brand-secondary-20": "#B6D5BF",
  "brand-secondary-10": "#D9EADC",
};

const consumer = {
  "secondary-70": "#2D3C3F",
  "secondary-60": "#2A616A",
  "secondary-50": "#5F797D",
  "secondary-30": "#B4D6DB",
  "secondary-20": "#D7F0F0",
  "secondary-10": "#EAF7F8",
};

const creator = {
  "creator-secondary-70": "#13183D",
  "creator-secondary-60": "#3C576D",
  "creator-secondary-50": "#5D7A79",
  "creator-secondary-30": "#90A9AA",
  "creator-secondary-20": "#B0C6C3",
  "creator-secondary-10": "#D3E1DE",
};

/**
 * Tertiary Color
 */
const warmGrey = {
  "warm-grey-40": "#CDC5BA",
  "warm-grey-30": "#E6E2DC",
  "warm-grey-20": "#EBE8E3",
  "warm-grey-10": "#F5F4F3",
  "warm-grey-5": "#FAF9F8",
};
const dustyRose = {
  "dusty-rose-40": "#A4999A",
  "dusty-rose-30": "#DBD6D7",
  "dusty-rose-20": "#E5DDDE",
  "dusty-rose-10": "#EDEBEB",
  "dusty-rose-5": "#F8F6F7",
};

const creamyTan = {
  "creamy-tan-40": "#EBD7C0",
  "creamy-tan-30": "#F0E2D0",
  "creamy-tan-20": "#F7EFE6",
  "creamy-tan-10": "#FBF7F2",
  "creamy-tan-5": "#FDFCFA",
};

const colors = {
  primary: primary["ltk-black"],
  secondary: consumer["secondary-50"],
  accent: consumer["secondary-30"],
  anchor: link["link-light"],
  success: success["success-40"],
  error: error["error-40"],
  warning: warning["warning-40"],
  ...primary,
  ...grey,
  ...success,
  ...warning,
  ...error,
  ...link,
  ...consumer,
  ...creator,
  ...brand,
  ...warmGrey,
  ...dustyRose,
  ...creamyTan,
};

export const light = colors;
export const dark = {
  ...colors,
  // Invert some of the blacks/whites for dark theming
  primary: primary["ltk-white"],
  anchor: link["link-dark"],
};
